import React, {useState} from 'react';
import {Button} from 'react-bootstrap';
import './../CustomNavBar/Styles.css';

const ScrollButton = () =>{
  
    const [visible, setVisible] = useState(false)
    
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;
      if (scrolled > 300){
        setVisible(true)
      } 
      else if (scrolled <= 300){
        setVisible(false)
      }
    };
    
    const scrollToTop = () =>{
      window.scrollTo({
        top: 0, 
        behavior: 'smooth'
        /* you can also use 'auto' behaviour
           in place of 'smooth' */
      });
    };
    
    window.addEventListener('scroll', toggleVisible);
    
    return (
      <Button className='ir-arriba'>
       <span onClick={scrollToTop} 
       style={{display: visible ? 'inline' : 'none'}}>UP</span>
      </Button>
    );
  }
    
  export default ScrollButton;